import { getAuthHeaders } from "../lib/auth";
import { useState, useEffect, useCallback } from "react";
import CourierLayout from "../components/CourierLayout";
import { CheckCircle2, XCircle, MapPin, Package, Truck, Calendar, ArrowRight } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const getHeaders = getAuthHeaders;

export default function CourierHistoryPage() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/log/courses`, { headers: getHeaders() });
      const all = res.data.courses || [];
      setCourses(all.filter(c => ["completed", "failed"].includes(c.status)));
    } catch (e) {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const completedCount = courses.filter(c => c.status === "completed").length;
  const failedCount = courses.filter(c => c.status === "failed").length;

  return (
    <CourierLayout title="Historique" subtitle="Courses terminees et echouees">
      <div data-testid="courier-history-page" className="space-y-4">
        {/* Summary */}
        <div className="flex gap-4">
          <div className="flex items-center gap-2 px-4 py-2 bg-green-500/100/10 border border-green-500/20 rounded-lg">
            <CheckCircle2 className="w-4 h-4 text-green-400" />
            <span className="text-sm text-green-400 font-medium">{completedCount} completee(s)</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-red-500/100/10 border border-red-500/20 rounded-lg">
            <XCircle className="w-4 h-4 text-red-400" />
            <span className="text-sm text-red-400 font-medium">{failedCount} echouee(s)</span>
          </div>
        </div>

        {/* List */}
        {loading ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-2 border-emerald-500 border-t-transparent" />
          </div>
        ) : courses.length === 0 ? (
          <div className="text-center py-16 bg-slate-900/60 rounded-xl border border-white/5">
            <Calendar className="w-10 h-10 text-slate-600 mx-auto mb-3" />
            <p className="text-slate-400 text-sm">Aucun historique</p>
          </div>
        ) : (
          <div className="space-y-2">
            {courses.map(course => (
              <div key={course.id} data-testid={`history-item-${course.id}`} className="bg-slate-900/60 border border-white/5 rounded-xl p-4">
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-start gap-3 flex-1 min-w-0">
                    <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${course.status === "completed" ? "bg-green-500/100/15" : "bg-red-500/100/15"}`}>
                      {course.status === "completed" ? <CheckCircle2 className="w-4 h-4 text-green-400" /> : <XCircle className="w-4 h-4 text-red-400" />}
                    </div>
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-medium text-white truncate">{course.title}</p>
                      <div className="flex items-center gap-2 mt-1 text-[10px] text-slate-500">
                        <MapPin className="w-3 h-3" />
                        <span className="truncate">{course.pickup_address}</span>
                        <ArrowRight className="w-3 h-3 text-slate-200" />
                        <span className="truncate">{course.delivery_address}</span>
                      </div>
                      <div className="flex items-center gap-3 mt-1 text-[10px] text-slate-600">
                        <span>{course.course_type === "assurance" ? "Assurance" : "Générale"}</span>
                        <span>{new Date(course.created_at).toLocaleDateString("fr-FR")}</span>
                        {course.completed_at && <span>Termine: {new Date(course.completed_at).toLocaleDateString("fr-FR")}</span>}
                      </div>
                    </div>
                  </div>
                  <span className={`px-2.5 py-1 rounded-full border text-[11px] font-medium flex-shrink-0 ${
                    course.status === "completed" ? "bg-green-500/100/20 text-green-400 border-green-500/30" : "bg-red-500/100/20 text-red-400 border-red-500/30"
                  }`}>
                    {course.status === "completed" ? "Terminée" : "Echouee"}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </CourierLayout>
  );
}
